import * as API from '../data/user_api';
import {signOutAction} from "./auth_actions";

export const GET_LIST = "get_list";
export const VIEW_DETAILS = "view_details";
export const EDIT_DETAILS = "edit_details";
export const UPDATE_DETAILS = "update_details";
export const CREATE = "create_new";
export const DELETE_DETAILS = "delete_details";
export const CLEAR_DATA = 'clear_data';

export function getList(URL) {
    return async (dispatch, getState) => {
        dispatch({type: CLEAR_DATA});
        if (!getState().auth.authenticated) {
            return;
        }
        const response = await API.getListingData(URL);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({type: GET_LIST, payload: response, source: URL});
        }
    };
}

export function getQuickSearchList(URL,propertyAddressId) {
    return async (dispatch, getState) => {
        dispatch({type: CLEAR_DATA});
        if (!getState().auth.authenticated) {
            return;
        }
        const response = await API.getQuickListingData(URL,propertyAddressId);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({type: GET_LIST, payload: response, source: URL});
        }
    };
}


export function viewDetails(data) {
    return (dispatch) => {
        dispatch({type: VIEW_DETAILS, payload: data});
    }
}

export function editDetails(data) {
    return (dispatch) => {
        dispatch({type: EDIT_DETAILS, payload: data});
    }
}

export function create(URL, data,successCallBack,addOn) {
    return async (dispatch) => {
        const response = await API.create(URL, data);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            successCallBack(response);
            dispatch({type: CREATE, payload: response});
            if(!addOn){
                this.getList(URL);
            }
        }
    };
}

export function updateDetails(URL, data, id,successCallBack,addOn) {
    return async (dispatch) => {
        const response = await API.update(URL, data, id);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({type: UPDATE_DETAILS, payload: response.data});
            if (response.data.success || response.data['agent_profile'] || response.data['admin_profile'] || response.data['clerk_profile'] || response.data['company_profile'] ) {
                if (!addOn) { this.getList(URL) };
            }
            if(successCallBack){
                successCallBack(response.data);
            }
        }
    };
}

export function deleteDetail(URL, id) {
    return async (dispatch) => {
        const response = await API.deleteDetail(URL, id);
        if(response.status === 401){
            dispatch(signOutAction());
        }
        else {
            dispatch({type: DELETE_DETAILS, payload: response.data});
            if (response.data.success || response.data['agent_profile'] || response.data['admin_profile'] || response.data['clerk_profile'] || response.data['company_profile']) {
                this.getList(URL);
            }
        }
    }
}


// WEBPACK FOOTER //
// ./src/actions/listing_action.js